module.exports = __webpack_public_path__ + "static/img/haerbin.5c5419f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/haerbin.jpg
// module id = gg83
// module chunks = 1